import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { MatTooltip, TooltipComponent, MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from './tooltip2.mjs';
import { MatCommonModule } from './common-module.mjs';
let MatTooltipModule = /*#__PURE__*/(() => {
  class MatTooltipModule {
    static ɵfac = function MatTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatTooltipModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatTooltipModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
      imports: [A11yModule, OverlayModule, MatCommonModule, MatCommonModule, CdkScrollableModule]
    });
  }
  return MatTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MatTooltipModule };
